import { datadogRum } from "@datadog/browser-rum";
import ServerUtil from "../utils/ServerUtil";

export function initDatadogRumIfTrackingEnabled() {
	if (ServerUtil.isPerformanceTrackingEnabled()) {
		datadogRum.init({
			applicationId: "93f05e57-368b-4f11-9bc2-e1c6f7495842",
			clientToken: "pub1424ee0b9ea88b1ef675752dc94667b6",
			site: "datadoghq.eu",
			service: "mshop::ui",
			env: ServerUtil.getDatadogEnvironment(),
			version: "1.0.0",
			sessionSampleRate: ServerUtil.getDatadogRumSampleRate(),
			sessionReplaySampleRate: ServerUtil.getDatadogRumPremiumSampleRate(),
			startSessionReplayRecordingManually: false,
			trackUserInteractions: true,
			trackResources: true,
			trackLongTasks: true,
			defaultPrivacyLevel: "mask-user-input",
			allowedTracingUrls: [window.location.origin],
			// https://webpack.js.org/guides/asset-modules/#url-assets
			workerUrl: new URL("@datadog/browser-worker", import.meta.url).toString(),
		});
		datadogRum.setGlobalContext({
			marc_id: "a1211",
			solution: "mshop",
			solution_id: "s00002",
			vertical: "ordercapture",
			project_id: ServerUtil.getGcpProjectId(),
		});
	}
}
